<div class="closure spacing--padding-all spacing--margin-all" data-test="closure">
  <form
    [formGroup]="closureForm"
    (ngSubmit)="save()"
    [agrConnectForm]="costs$"
    *ngIf="cycle$ | async as cycle"
  >
    <div class="flex--column" *ngIf="location$ | async as location">
      <div class="flex--column">
        <mat-form-field class="flex__child--auto">
          <span matTextPrefix class="spacing--padding-half-right">
            {{ cycle.currency | agrCurrencySymbol }}
          </span>
          <mat-label>{{ 'water' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            [enableStepArrows]="false"
            data-test="total-costs__water"
            formControlName="water"
          />
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <span matTextPrefix class="spacing--padding-half-right">
            {{ cycle.currency | agrCurrencySymbol }}
          </span>
          <mat-label>{{ 'heating' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            [enableStepArrows]="false"
            data-test="total-costs__heating"
            formControlName="heating"
          />
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <span matTextPrefix class="spacing--padding-half-right">
            {{ cycle.currency | agrCurrencySymbol }}
          </span>
          <mat-label>{{ 'electricity' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            [enableStepArrows]="false"
            data-test="total-costs__electricity"
            formControlName="electricity"
          />
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <span matTextPrefix class="spacing--padding-half-right">
            {{ cycle.currency | agrCurrencySymbol }}
          </span>
          <mat-label>{{ 'cadaver' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            [enableStepArrows]="false"
            data-test="total-costs__cadaver"
            formControlName="cadaver"
          />
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <span matTextPrefix class="spacing--padding-half-right">
            {{ cycle.currency | agrCurrencySymbol }}
          </span>
          <mat-label>{{ 'certification' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            [enableStepArrows]="false"
            data-test="total-costs__certification"
            formControlName="certification"
          />
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <span matTextPrefix class="spacing--padding-half-right">
            {{ cycle.currency | agrCurrencySymbol }}
          </span>
          <mat-label>{{ 'healthcare' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            [enableStepArrows]="false"
            data-test="total-costs__healthcare"
            formControlName="healthCare"
          />
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <span matTextPrefix class="spacing--padding-half-right">
            {{ cycle.currency | agrCurrencySymbol }}
          </span>
          <mat-label>{{ 'litter' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            [enableStepArrows]="false"
            data-test="total-costs__litter"
            formControlName="litter"
          />
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <span matTextPrefix class="spacing--padding-half-right">
            {{ cycle.currency | agrCurrencySymbol }}
          </span>
          <mat-label>{{ 'catching' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            [enableStepArrows]="false"
            data-test="total-costs__catching"
            formControlName="catching"
          />
        </mat-form-field>

        <mat-form-field
          *ngIf="
            location.country === 'NL' || location.country === 'BE' || location.country === 'DE'
          "
          class="flex__child--auto"
        >
          <span matTextPrefix class="spacing--padding-half-right">
            {{ cycle.currency | agrCurrencySymbol }}
          </span>
          <mat-label>{{ 'manure' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            [enableStepArrows]="false"
            data-test="total-costs__manure"
            formControlName="manure"
          />
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <span matTextPrefix class="spacing--padding-half-right">
            {{ cycle.currency | agrCurrencySymbol }}
          </span>
          <mat-label>{{ 'decontamination' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            [enableStepArrows]="false"
            data-test="total-costs__decontamination"
            formControlName="decontamination"
          />
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <span matTextPrefix class="spacing--padding-half-right">
            {{ cycle.currency | agrCurrencySymbol }}
          </span>
          <mat-label>{{ 'water-additives' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [enableStepArrows]="false"
            [step]="0.01"
            data-test="total-costs__water-additives"
            formControlName="waterAdditives"
          />
        </mat-form-field>

        <mat-form-field
          *ngIf="
            location.country === 'NL' || location.country === 'BE' || location.country === 'DE'
          "
          class="flex__child--auto"
        >
          <span matTextPrefix class="spacing--padding-half-right">
            {{ cycle.currency | agrCurrencySymbol }}
          </span>
          <mat-label>{{ 'avined' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            [enableStepArrows]="false"
            data-test="total-costs__avined"
            formControlName="avined"
          />
        </mat-form-field>

        <mat-form-field
          *ngIf="
            location.country !== 'NL' && location.country !== 'BE' && location.country !== 'DE'
          "
          class="flex__child--auto"
        >
          <span matTextPrefix class="spacing--padding-half-right">
            {{ cycle.currency | agrCurrencySymbol }}
          </span>
          <mat-label>{{ 'veterinary' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            [enableStepArrows]="false"
            data-test="total-costs__veterinary"
            formControlName="veterinary"
          />
        </mat-form-field>

        <mat-form-field
          *ngIf="
            location.country !== 'NL' && location.country !== 'BE' && location.country !== 'DE'
          "
          class="flex__child--auto"
        >
          <span matTextPrefix class="spacing--padding-half-right">
            {{ cycle.currency | agrCurrencySymbol }}
          </span>
          <mat-label>{{ 'employment' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            [enableStepArrows]="false"
            data-test="total-costs__employment"
            formControlName="employment"
          />
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <span matTextPrefix class="spacing--padding-half-right">
            {{ cycle.currency | agrCurrencySymbol }}
          </span>
          <mat-label>{{ 'otherCosts' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            [enableStepArrows]="false"
            data-test="total-costs__otherCosts"
            formControlName="otherCosts"
          />
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <span matTextPrefix class="spacing--padding-half-right">
            {{ cycle.currency | agrCurrencySymbol }}
          </span>
          <mat-label>{{ 'otherRevenue' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [step]="0.01"
            [enableStepArrows]="false"
            data-test="total-costs__otherRevenue"
            formControlName="otherRevenue"
          />
        </mat-form-field>

        <div
          class="costs__total spacing--margin-top spacing--margin-bottom"
          data-test="costs__total"
        >
          <span class="text--bold">{{ 'total' | translate }}:</span>
          {{ cycle.currency | agrCurrencySymbol }}
          {{ closureForm.controls.total.value | agrNumber }}
        </div>
      </div>
    </div>

    <div class="mat-button-row spacing--padding-top">
      <button
        type="submit"
        mat-flat-button
        class="flex__child"
        color="primary"
        data-test="costs__save"
      >
        {{ 'save' | translate }}
      </button>
    </div>
  </form>
</div>
